import sendingLmraDataHelper from "@/helpers/sendingLmraDataHelper";

const missingSessionData = 'missing-session-data';
const couldNotSaveSession = 'could-not-save-session';
const invalidSessionData = 'invalid-session-data';

export default {
    data: ()=>{
        return {
            saveSessionError : null,
            formDisabled : false
        }
    },
    methods :{
        async handleLMRAVariantServerResponse(responseData){
            let message = this.$vuetify.lang.t('$vuetify.global.post_success');
            if(responseData.message !== undefined){
                message = responseData.message;
            }

            let saveState = await this.saveNewWorkSession(responseData)

            if(saveState){
                sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(message)
                this.$router.replace('/');
            }else{
                window.console.log('WTF ...');
                window.console.log(this.saveSessionError);
                sendingLmraDataHelper.notifyUserOfLMRADataSendStatus(this.saveSessionError);
                this.formDisabled = false;
            }

            window.console.log('RESPONSE DATA');
            window.console.log(responseData);
            //SAVE THE CURRENT SESSION!
            //TODO HANDLE SESSION HERE !!!
        },
        async saveNewWorkSession(responseData){
            this.saveSessionError = null;
            if(responseData.session == undefined || responseData.session == null){
                this.saveSessionError = missingSessionData;
                return false
            }
            if(this.$workSessions.validateWorkSessionObject(responseData.session)){
                let saveState = await this.$store.dispatch('saveValidatedAndVerifiedWorkSession', responseData.session);
                if(!saveState){
                    this.saveSessionError = couldNotSaveSession;
                }
                return saveState;
            }else{
                this.saveSessionError = invalidSessionData
                return false;
            }
        },
        getSaveWorkSessionError($error){
            let message = 'Unknown error occurred';
            switch ($error){
                case missingSessionData:
                    message = this.$vuetify.lang.t('$vuetify.workSessions.lmraVariants.errors.missing_session_data')
                    break;
                case couldNotSaveSession:
                    message = this.$vuetify.lang.t('$vuetify.workSessions.lmraVariants.errors.could_not_save_session')
                    break;
                case invalidSessionData:
                    message = this.$vuetify.lang.t('$vuetify.workSessions.lmraVariants.errors.invalid_session_data')
                    break;

            }
            return message;
        }
    }

}